import { render } from "./ModalInformativoProdutos.vue?vue&type=template&id=add2768c&scoped=true"
import script from "./ModalInformativoProdutos.vue?vue&type=script&lang=js"
export * from "./ModalInformativoProdutos.vue?vue&type=script&lang=js"

import "./ModalInformativoProdutos.vue?vue&type=style&index=0&id=add2768c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add2768c"]])

export default __exports__